module.exports = __webpack_public_path__ + "img/example.1c2bcdcc.svg";